// extracted by mini-css-extract-plugin
export default {"intellect-card-style":"index_intellect-card-style__AkcV-"};